import fetch from "cross-fetch"

import { getDefaultHeaders, handleErrors } from "core/api"
import endpoints from "core/endpoints"

class AuthorsAPI {
  fetchList() {
    return handleErrors(
      fetch(endpoints.authorsList(), {
        method: "get",
        headers: getDefaultHeaders(),
      })
    )
  }
}

export default new AuthorsAPI()
